import { Card, CardHeader, Grid, useMediaQuery, useTheme } from "@mui/material";
// Overview page components
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DashboardLayout from "~/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "~/examples/Navbars/DashboardNavbar";

// Material Dashboard 2 React components
import { useMutation } from "@tanstack/react-query";
import { Pagination, Spin, Typography } from "antd";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import EmptyResult from "~/components/Extras/Empty";
import MDBox from "~/components/MDBox";
import MDButton from "~/components/MDButton";
import MiniDetailsWaveCard from "~/examples/Cards/MiniDetailsWaveCard";
import usePagination from "~/hooks/usePagination";
import dashboardServices from "~/services/dashboard.services";
import { setClickedCardIndex } from "~/store/slices/utilities";

const Plots = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();

  const matchesXs = useMediaQuery(theme.breakpoints.only("md"));

  const { data, isLoading, mutateAsync, mutate, reset } = useMutation({
    mutationKey: ["Plot", location.state?.Loc_Auto_ID],
    mutationFn: (payloads) =>
      dashboardServices.getPlotDataBasedOnLocation(payloads),
  });

  const { currentPage, handlePageChange, pageSize } = usePagination(
    mutate,
    location.state?.Loc_Auto_ID,
    matchesXs ? 6 : 8
  );

  useEffect(() => {
    mutate({ id: location.state?.Loc_Auto_ID, currentPage, pageSize });

    return () => {
      reset();
    };
  }, []);
  
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <MDBox>
          <CardHeader
            action={
              <MDButton
                variant="contained"
                color="success"
                aria-label="navigation"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(-1, { replace: true })}
              >
                Back
              </MDButton>
            }
            title={location.state?.name}
            subheader={
              <Typography.Title level={5}>
                Location area <sup>Hect.</sup> :{" "}
                {location.state?.Loc_Total_Area ?? ""}
              </Typography.Title>
            }
          />
          {/* <MDTypography variant="caption">
            Number of Plants : {location.state?.total_plant}
          </MDTypography> */}
        </MDBox>

        <MDBox mt={2}>
          <MDBox mb={3} p={2}>
            <Spin tip="loading..." spinning={isLoading}>
              <Grid container spacing={3}>
                {/* if no items in the data [] */}
                {data?.data?.length === 0 ? (
                  <Grid item xs={12} md={12} xl={12} lg={12}>
                    <EmptyResult
                      description=" No data available. Click below to create new Plotting"
                      navigateTo="/plotting-master/create"
                    />
                  </Grid>
                ) : null}
                <Grid item xs={12} lg={12}>
                  <Grid container spacing={3}>
                    {data?.data.map((item, index) => (
                      <Grid
                        item
                        xs={12}
                        md={6}
                        xl={3}
                        lg={3}
                        key={item?.Plot_Code}
                        sx={{ display: "flex", justifyContent: "center" }}
                      >
                        {/* <Card
                          sx={{ cursor: 'pointer' }}
                          onClick={() => {
                            navigate(
                              `/dashboard/location/plots/${item?.Plot_Code}-${item?.Plot_Name}`,
                              {
                                state: {
                                  ...item,
                                  Loc_Name: location.state?.Loc_Name,
                                  name: `${item?.Plot_Code}/${item?.Plot_Name}`,
                                },
                              },
                            );
                          }}
                        > */}
                        {/*
                          {/* <DefaultInfoCard
                            icon="pin_drop"
                            title={`${item?.Plot_Code}/${item?.Plot_Name}`}
                            description={`Plotting area (hect): ${item?.Plot_Area}`}
                            value={`Number of Plants : ${item?.Total_Planting_Count}`}
                          /> 
                        */}
                        {/* <MiniDetailsCard
                          style={{ cursor: 'pointer' }}
                          title={`${item?.Plot_Code}/${item?.Plot_Name}`}
                          value={`Number of Plants : ${item?.Total_Planting_Count}`}
                          description={`Plotting Area: ${item?.Plot_Area}`}
                          onClick={() => {
                            navigate(
                              `/dashboard/location/plots/${item?.Plot_Code}-${item?.Plot_Name}`,
                              {
                                state: {
                                  ...item,
                                  Loc_Name: location.state?.Loc_Name,
                                  name: `${item?.Plot_Code}/${item?.Plot_Name}`,
                                },
                              },
                            );
                          }}
                        /> */}
                        <MiniDetailsWaveCard
                          route="plots"
                          index={item?.Plot_Code}
                          style={{ cursor: "pointer" }}
                          title={`${item?.Plot_Code}/${item?.Plot_Name}`}
                          description={`Plotting Area: ${item?.Plot_Area}`}
                          lat={+item?.Latitude}
                          long={+item?.Longitude}
                          plantsCount={item?.Total_Planting_Count}
                          plantationType={item?.plantationCount}
                          plantationLocations={item?.plantationLocations}
                          /* new changes - tag v3.0.1 */
                          cardDetails={[
                            {
                              value: `Number of Plants : ${item?.Total_Planting_Count}`,
                            },
                            {
                              value: `Land Use : ${item?.Land_Use ?? ""}`,
                            },
                            {
                              value: `Aspect : ${item?.Aspect ?? ""}`,
                            },
                            {
                              value: `Soil Texture : ${
                                item?.Soil_Texture ?? ""
                              }`,
                            },
                            {
                              value: `Presence of Weed or Grass : ${
                                item?.Presence_of_Weed_or_Grass ?? "No"
                              }`,
                            },
                          ]}
                          onClick={() => {
                            // Update the clicked card index in the state
                            dispatch(
                              setClickedCardIndex({
                                route: "plots",
                                index: item?.Plot_Code,
                              })
                            );
                            navigate(
                              `/dashboard/location/plots/${item?.Plot_Code}-${item?.Plot_Name}`,
                              {
                                state: {
                                  ...item,
                                  Loc_Name: location.state?.Loc_Name,
                                  name: `${item?.Plot_Code}/${item?.Plot_Name}`,
                                },
                              }
                            );
                          }}
                        />
                        {/* </Card> */}
                      </Grid>
                    ))}
                  </Grid>
                </Grid>

                <Grid
                  item
                  lg={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Pagination
                    defaultPageSize={matchesXs ? 6 : 8}
                    defaultCurrent={currentPage}
                    total={data?.count ?? 10}
                    onChange={handlePageChange}
                    showTotal={(total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`
                    }
                  />
                </Grid>
              </Grid>
            </Spin>
          </MDBox>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
};

export default Plots;
